/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Input, TrashIcon } from '@avila-tek/ui/src';
import { PaymentData, PaymentMethod } from '../../../models';

interface PaymentDataInputProps {
  paymentData: PaymentData;
  setFormState: React.Dispatch<React.SetStateAction<Partial<PaymentMethod>>>;
  idx: number;
}

function PaymentDataInput({
  paymentData,
  setFormState,
  idx,
}: PaymentDataInputProps) {
  const handleInputChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormState((state) => {
      const newPaymentData = [...state.paymentData];
      newPaymentData[idx] = {
        ...newPaymentData[idx],
        [name]: value,
      };
      return {
        ...state,
        paymentData: newPaymentData,
      };
    });
  };

  const removePaymentData = (index: number) => {
    setFormState((formState) => {
      const newPaymentData = [...formState.paymentData];
      newPaymentData.splice(idx, 1);
      return {
        ...formState,
        paymentData: [...newPaymentData],
      };
    });
  };

  return (
    <div className="w-full flex md:flex-row flex-col gap-4 items-center">
      <div className="w-full">
        <Input
          value={paymentData.name}
          label="Nombre"
          name="name"
          type="text"
          placeholder="Ingrese un nombre"
          onChange={handleInputChange}
          data-idx
          required
        />
      </div>
      <div className="w-full">
        <Input
          value={paymentData.value}
          label="Valor"
          name="value"
          type="text"
          placeholder="Ingrese el valor"
          onChange={handleInputChange}
          required
        />
      </div>
      <button type="button" onClick={() => removePaymentData(idx)}>
        <TrashIcon className="w-6 h-6 mt-5 text-danger-200" />
      </button>
    </div>
  );
}

export default PaymentDataInput;
